import React, { Component } from 'react';
import {
  Container,
} from 'reactstrap';
import AdminContainer from '../components/Admin/AdminContainer';

class Companies extends Component {

  componentDidMount = () => {
    this.props.log('Companies.js/componentDidMount');
  }

  render() {
    return (<Container fluid={true}>
      <AdminContainer
        {...this.props}
        showUsers={false}
        showRoles={false}
        showPermissions={false}
        showClients={true}
      />
    </Container>
    );
  }
}

export default Companies;
